<template>
  <div v-loading.fullscreen.lock="fullScreenLoading" />
</template>

<script>
export default {
  name: "ConfirmPayment",
  data: () => ({
    stripe: {},
    fullScreenLoading: true,
  }),
  async created() {
    this.stripe = window.Stripe(
      process.env.VUE_APP_PAYMENT_STRIPE_PUBLISH_KEY,
      {
        locale: this.$i18n.locale,
      }
    );
    await this.checkPaymentResponse();
  },
  methods: {
    async checkPaymentResponse() {
      const url = new URL(window.location);
      const clientSecret = url.searchParams.get("payment_intent_client_secret");
      if (clientSecret) {
        const self = this;
        this.stripe
          .retrievePaymentIntent(clientSecret)
          .then(async function(response) {
            if (
              response.paymentIntent &&
              response.paymentIntent.status === "succeeded"
            ) {
              await self.processPayment({ token: response.paymentIntent });
            } else {
              self.$message.error(self.$t("pay.not-processed"));
              window.location.href = `${process.env.VUE_APP_BASE_URL}/#/pay/${self.$route.params.qrCodes}/${self.$route.params.currency}`;
            }
            self.fullScreenLoading = false;
          })
          .catch(() => {
            this.fullScreenLoading = false;
          });
      } else {
        this.fullScreenLoading = false;
        this.$message.error(this.$t("pay.not-processed"));
        const qrCodes = this.$route.params.qrCodes.split(",");
        const redirectPage = qrCodes.length > 1 ? "multiple-pay" : "pay";
        setTimeout(() => {
          window.location.href = `${process.env.VUE_APP_BASE_URL}/#/${redirectPage}/${this.$route.params.qrCodes}/${this.$route.params.currency}`;
        }, 1000);
      }
    },
    async processPayment(paymentData) {
      await this.$axios
        .put(`/api/v1/tx/${this.$route.params.txId || ""}`, {
          qrCodes: this.$route.params.qrCodes.split(",").map(Number),
          currency: this.$route.params.currency,
          amount: this.$route.params.amount,
          payData: JSON.stringify(paymentData.token),
          payerEmail: paymentData.payerEmail || "",
        })
        .then((response) => {
          if (response.data.status === "Success") {
            window.location.href = `${
              process.env.VUE_APP_BASE_URL
            }/#/receipt/${this.$route.params.txId ||
              response.data.payload.txId}`;
          } else {
            this.$message.error(this.$t("pay.not-processed"));
            const qrCodes = this.$route.params.qrCodes.split(",");
            const redirectPage = qrCodes.length > 1 ? "multiple-pay" : "pay";
            window.location.href = `${process.env.VUE_APP_BASE_URL}/#/${redirectPage}/${this.$route.params.qrCodes}/${this.$route.params.currency}`;
          }
        })
        .catch(() => {
          const qrCodes = this.$route.params.qrCodes.split(",");
          this.$message.error(this.$t("pay.not-processed"));

          const redirectPage = qrCodes.length > 1 ? "multiple-pay" : "pay";
          window.location.href = `${process.env.VUE_APP_BASE_URL}/#/${redirectPage}/${this.$route.params.qrCodes}/${this.$route.params.currency}`;
        });
    },
  },
};
</script>

<style scoped></style>
